// Libs
import { createSelector } from 'reselect'
import _find from 'lodash/find'

// Selectors
import selectedJob$ from 'hfty-soil-jobs/src/selectors/selectedJob'
import { assets$ } from 'fc-assets'


export default createSelector(
  [
    assets$,
    selectedJob$,
  ],
  (assets, selectedJob) => {
    if (selectedJob) {
      const subfieldObj = _find(assets, (asset) => {
        return asset.id === selectedJob.subfield
      })
      if (subfieldObj) {
        const fieldObj = _find(assets, (asset) => {
          return asset.id === subfieldObj.parent
        })
        if (fieldObj) {
          return fieldObj
        }
      }
    }

    return null
  }
)
